import ViewBase from "../../view-base.view";
import 'CssFolder/schedule/jpo/jpo-calendar.scss';

import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import { formats as FORMATS } from '../../../config/constants';
import moment from "moment";
import JPOScheduleMapView from "./jpo-schedule-map.view";
import jpoScheduleModel from "../../../models/schedule/jpo-schedule.model";
import { v4 as uuid } from "uuid";
import { Icon, Icons, Intent } from "construct-ui";

export default function JPOScheduleCalendarDayView() {
    ViewBase.call(this);
    let userId;
    let schedules = [];
    let inputFilterDate;
    let dataVersion;
    let totalTime = 0;
    const getScheduleRoute = () => {
        this.showLoading();
        jpoScheduleModel.getScheduleRoute(
            (result) => {
                massageData(result.data);
                dataVersion = uuid();
                this.hideLoading();
            },
            (error) => {
                this.hideLoading();
                this.handleError(error);
            },
            {
                userId: userId,
                fromDate: moment(inputFilterDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
                toDate: moment(inputFilterDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
                pageIndex: 1,
                pageSize: 300
            })

    }
    const massageData = (data) => {
        //totalTime = data.reduce((s, d) => s + (d.planDwellTime * 60) + (d.sequence == 1 ? 0 : d.planTravelingTime), 0);
        totalTime = data.reduce((s, d) => s + (d.planDwellTime * 60) + d.planTravelingTime, 0);
        schedules = data;
    }
    const displayJPOM = () => {
        if (schedules.length > 0 && schedules.findIndex(o => o.scheduleSource == 2) >= 0){
            return m('.day-jpom', "m");  
        }
     } 

    return {
        oninit: ({ attrs }) => {
            userId = attrs.userId;
            inputFilterDate = moment(attrs.scheduleDate, FORMATS.apiDateFormat).format(FORMATS.dateFormat);
            getScheduleRoute();
        },
        oncreate: function (vnode) {
            document.querySelector(".easepick-wrapper").style.left = "-72px";

        },
        view: (vnode) => {
            return [
                
                m('.day-date', [
                    displayJPOM(),
                         
                    m('.day-calendar', m(DatePickerComponent, {
                        class: 'form-control',
                        date: inputFilterDate,
                        onselect: (e) => {
                            inputFilterDate = moment(e.detail.date).format(FORMATS.dateFormat);
                            getScheduleRoute();
                        }
                    }))
                ]),                 
                m('.day-ctr', [

                    schedules.length > 0 ? m('.d-item-ctr', [
                        m('.d-item-sub-ctr', [
                            schedules.map((schedule) => m('.d-item', [
                                m('.d-item-title', schedule.siteName),
                                m('.d-item-time', [
                                    m(Icon,
                                        {
                                            name: Icons.CLOCK,
                                            intent: Intent.PRIMARY
                                        }
                                    ),
                                    m('span',{style:'padding-left:10px'}, `${schedule.startTime} ~ ${schedule.endTime}`)
                                ])
                            ])),
                        ]),
                        m('.d.item-footer', `${schedules.length} Store(s) -${(totalTime / 3600) >= 1 ? `${parseInt(totalTime / 3600)} hour` : ''} ${parseInt((totalTime % 3600) / 60)} min`)
                    ]) : null,
                    m('div', { style: "flex:1;width:100%;height:100%" },
                        m(JPOScheduleMapView, {
                            schedules: schedules,
                            colors: vnode.attrs.colors,
                            dataVersion: dataVersion,
                            zoom: 10
                        }))
                ]),
                this.getBaseViews()
            ]
        }
    }
}